module.exports = __webpack_public_path__ + "static/media/nima_waving_hand.5bd67bf9.gif";